import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { categories } from '@/mocks/categories';

export default function CategoryQuickLinks() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-[1280px] mx-auto">
        <SectionHeading
          icon="ri-grid-line"
          title="分类快捷入口"
          subtitle="按兴趣直达你想看的内容频道"
        />
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {categories.map((cat, idx) => (
            <Link
              key={cat.key}
              to={cat.path}
              className={`group flex flex-col p-4 md:p-5 rounded-lg border transition-colors cursor-pointer ${
                idx === 0
                  ? 'bg-primary-500 border-primary-500 hover:bg-primary-600'
                  : 'bg-background-50 border-background-200 hover:border-primary-300'
              }`}
            >
              <span
                className={`w-11 h-11 rounded-lg flex items-center justify-center text-2xl mb-4 ${
                  idx === 0 ? 'bg-background-50/20 text-background-50' : 'bg-primary-100 text-primary-700'
                }`}
              >
                <i className={cat.icon} />
              </span>
              <h3
                className={`font-heading text-base md:text-lg font-bold ${
                  idx === 0 ? 'text-background-50' : 'text-foreground-950'
                }`}
              >
                {cat.name}
              </h3>
              <p
                className={`text-xs md:text-sm mt-1.5 leading-relaxed flex-1 ${
                  idx === 0 ? 'text-background-100' : 'text-foreground-600'
                }`}
              >
                {cat.description}
              </p>
              <span
                className={`flex items-center gap-1 text-xs mt-4 ${
                  idx === 0 ? 'text-background-50' : 'text-foreground-500'
                }`}
              >
                {cat.count}
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}